import { render, staticRenderFns } from "./FechaHora.vue?vue&type=template&id=6accadf4&scoped=true"
import script from "./FechaHora.vue?vue&type=script&lang=js"
export * from "./FechaHora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6accadf4",
  null
  
)

export default component.exports